export default __webpack_public_path__ + "static/media/npm.4c28f43a.png";